interface PopupDialogueProps {
    open: boolean;
    children: React.ReactElement;
    onClose: () => void;
}

const Popover = ({ open, children, onClose }: PopupDialogueProps) => {
    if (!open) return null;

    return (
        <div className="fixed z-20 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-center justify-center min-h-screen text-center">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>
                <div className="inline-block align-bottom rounded-lg text-left overflow-hidden shadow-xl transform transition-all">{children}</div>
            </div>
        </div>
    );
};

export default Popover;
